export default class Dictionary<T> {

    _keys: Array<string> = new Array<string>();
    _values: T[] = new Array<T>();

    constructor(init: { key: string; value: T; }[] = null) {
        if (!init)
            return;
        for (var x = 0; x < init.length; x++) {
            this[init[x].key] = init[x].value;
            this._keys.push(init[x].key);
            this._values.push(init[x].value);
        }
    }

    add(key: string, value: T) {
        if (this.containsKey(key))
        {
            var index = this._keys.indexOf(key, 0);
            this[key] = value;
            this._keys.splice(index, 1, key);
            this._values.splice(index, 1, value);
        }
        else{
            this[key] = value;
            this._keys.push(key);
            this._values.push(value);
        }
    }

    get(key: string): T{
        return this[key];
    }   

    remove(key: string) {
        var index = this._keys.indexOf(key, 0);
        this._keys.splice(index, 1);
        this._values.splice(index, 1);

        delete this[key];
    }

    keys(): string[] {
        return this._keys;
    }

    values(): T[] {
        return this._values;
    }

    containsKey(key: string): boolean {
        if (typeof this[key] === "undefined") {
            return false;
        }

        return true;
    }
}